import React from 'react'
import { Fragment } from 'react'
import CustomTable from '../../../../elements/Table/CustomTable'
import MoneyCell from '../../../../elements/Table/Cells/MoneyCell'
import { numVal } from '../../../../modules/Utils'
import { Link } from 'react-router-dom'
import checkboxHOC from 'react-table-v6/lib/hoc/selectTable'
import { Button } from 'antd'
import UpperCaseCell from '../../../../elements/Table/Cells/UpperCaseCell'

const CheckboxTable = checkboxHOC(CustomTable)

SalariesList.propTypes = {}
const columns = [
  {
    Header: 'SystemID',
    accessor: '_key',
    Cell: ({ value, original }) => (
      <Link
        to={{
          pathname: `/people/salaries/${original._key}/update`,
        }}>
        {value}
      </Link>
    ),
  },

  { accessor: 'employee.fn', Header: 'Employee' },
  { accessor: 'date', Header: 'Period End' },
  {
    accessor: 'amount',
    Header: 'Amount',
    Cell: ({ value, original }) => <MoneyCell value={value} currency={original.currency} />,
  },
]
const subColumns = [
  { Header: 'Name', accessor: 'name' },
  { Header: 'Category', accessor: 'category', Cell: UpperCaseCell },
  { Header: 'Type', accessor: 'type' },
  { Header: 'Account', accessor: 'account.name', hideable: true },
  { Header: 'Amount', accessor: 'amount', Cell: MoneyCell },
]

function SalariesList(props) {
  const {
    generatedData,
    onGenerate,
    fetch,
    fetching,
    generating,
    isNew,
    payroll,
    toggleSelection,
    isSelected,
    toggleAll,
    selectAll,
    selection,
    tableRef,
    createPayClaim,
    submittingPayClaim,
    isApproved,
  } = props
  const checkboxProps = {
    selectType: 'checkbox',
    toggleSelection,
    isSelected,
    toggleAll,
    selectAll,
    selection,
  }

  return (
    <CheckboxTable
      {...checkboxProps}
      withRef={tableRef}
      columns={columns.filter(c => (isNew ? c.accessor !== '_key' : c))}
      data={isNew ? generatedData : payroll.lines}
      fetch={isNew ? onGenerate : fetch}
      fetching={isNew ? generating : fetching}
      defaultPageSize={20}
      CreateButton={() => (
        <Fragment>
          <Button
            onClick={createPayClaim}
            size={'small'}
            type={'primary'}
            disabled={!isApproved || selection.length === 0}
            loading={submittingPayClaim}
            icon={'file-protect'}>
            Create pay claim
          </Button>
        </Fragment>
      )}
      SubComponent={row => {
        return (
          <div style={{ padding: '20px' }}>
            <CustomTable
              CreateButton={() => <strong>{row.original.employee.fn}</strong>}
              data={row.original.lines}
              columns={subColumns}
              showPagination={false}
              hide={{ filter: true, refresh: true }}
              defaultPageSize={numVal(row, 'original.lines.length')}
            />
          </div>
        )
      }}
    />
  )
}

export default SalariesList
